/**
     * Convierte fecha en formato String a Date.
     * @param {String} dateString - Fecha en formato String
     * @returns {Date} Fecha en formato Date.
    */
function stringToDate(dateString){
    const dateParts = dateString.split("/");
    const date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return date;
}

export default stringToDate;